// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Header from "./Header.bs.js";
import * as CustomSidebar from "../../../pricing-dashboard/view/components/library/reuseable-components/CustomSidebar.bs.js";
import * as PlaceOrderCmp from "./PlaceOrderCmp.bs.js";
import * as PlaceOrderData from "../../app/entity/PlaceOrderData.bs.js";
import * as PlaceOrderAssetsManager from "../assets/PlaceOrderAssetsManager.bs.js";
import * as PlaceOrderDataProviderHOC from "../context/PlaceOrderDataProviderHOC.bs.js";

PlaceOrderAssetsManager.importCss(undefined);

function PlaceOrderContainerCmp(Props) {
  var onClosePlaceOrderPanel = Props.onClosePlaceOrderPanel;
  var updatedInitialStateOpt = Props.updatedInitialState;
  var customerInfo = Props.customerInfo;
  var updatedInitialState = updatedInitialStateOpt !== undefined ? updatedInitialStateOpt : PlaceOrderData.initialState;
  return React.createElement("div", {
              className: "c-place-order"
            }, React.createElement(PlaceOrderDataProviderHOC.make, {
                  children: React.createElement(CustomSidebar.make, {
                        is_open: true,
                        on_back_drop_click: (function (param) {
                            return Curry._1(onClosePlaceOrderPanel, undefined);
                          }),
                        children: null
                      }, React.createElement(Header.make, {
                            onCloseClick: onClosePlaceOrderPanel
                          }), React.createElement(PlaceOrderCmp.make, {
                            onClosePlaceOrderPanel: onClosePlaceOrderPanel
                          })),
                  updatedInitialState: {
                    currentStep: updatedInitialState.currentStep,
                    pickupAddress: updatedInitialState.pickupAddress,
                    dropAddress: updatedInitialState.dropAddress,
                    selectedVehicle: updatedInitialState.selectedVehicle,
                    geo_region: updatedInitialState.geo_region,
                    goods_type: updatedInitialState.goods_type,
                    customerInfo: customerInfo,
                    isRebook: updatedInitialState.isRebook,
                    snackbarMessage: updatedInitialState.snackbarMessage,
                    wayPointOne: updatedInitialState.wayPointOne,
                    wayPointTwo: updatedInitialState.wayPointTwo,
                    wayPointThree: updatedInitialState.wayPointThree,
                    restricted_vehicles: updatedInitialState.restricted_vehicles,
                    vehicles: updatedInitialState.vehicles,
                    parentOrderId: updatedInitialState.parentOrderId,
                    selectedGoodsType: updatedInitialState.selectedGoodsType
                  }
                }));
}

var make = PlaceOrderContainerCmp;

export {
  make ,
  
}
/*  Not a pure module */
